import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-menu-screen',
  templateUrl: './menu-screen.component.html',
  styleUrls: ['./menu-screen.component.css']
})
export class MenuScreenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
